import React from 'react';
import { InputNumberProps } from 'antd';
import * as S from '../styles';

interface CurrencyInputProps extends InputNumberProps {
	placeholder?: string;
}

const DOTS_PATTERN = /\./g;
const NON_DIGITS_PATTERN = /\D/g;
const THOUSANDS_SEPARATOR_PATTERN = /\B(?=(\d{3})+(?!\d))/g;

export function CurrencyInput({ placeholder = '', ...props }: Readonly<CurrencyInputProps>) {
	function handleValueFormat(value: string | number | undefined): string {
		if (!value) return '';
		return String(value).replace(NON_DIGITS_PATTERN, '').replace(THOUSANDS_SEPARATOR_PATTERN, '.');
	}

	function handleValueParser(value: string | undefined): number {
		if (!value) return 0;
		return Number(String(value).replace(DOTS_PATTERN, '').replace(',', '.'));
	}

	return (
		<S.InputNumberWrapper
			{...props}
			min={0}
			addonBefore="$"
			placeholder={placeholder}
			parser={handleValueParser}
			formatter={handleValueFormat}
			style={{ width: '100%', textAlign: 'center' }}
		/>
	);
}
